import '@babel/polyfill'
import { createRoot } from 'react-dom/client'
import * as React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'
import config from 'auth_config.json'
import { ThemeProvider } from '@mui/material/styles'
import theme from 'theme'
import TagManager from 'react-gtm-module'
import {
  // IS_BOOKING,
  BASE_URL,
  HOST_KEYS,
  IS_PRODUCTION,
} from 'utils/constants'
import App from 'containers/App'
/* eslint-disable import/no-unresolved, import/extensions */
import '!file-loader?name=[name].[ext]!./images/favicon.ico'
import 'file-loader?name=.htaccess!./.htaccess'
/* eslint-enable import/no-unresolved, import/extensions */
import Header from 'components/Header'
import Footer from 'components/Footer'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { LicenseInfo } from '@mui/x-license-pro'
import configureStore from './configureStore'
import GlobalStyle from './global-styles'
import { API_KEYS } from 'utils/constants'

const MOUNT_NODE = document.getElementById('app')
const HEADER_NODE = document.getElementById('header')
const FOOTER_NODE = document.getElementById('footer')

const mountRoot = MOUNT_NODE ? createRoot(MOUNT_NODE) : null
const sidenavRoot = HEADER_NODE ? createRoot(HEADER_NODE) : null
const footerRoot = FOOTER_NODE ? createRoot(FOOTER_NODE) : null

const initialState = {}
const store = configureStore(initialState)

if (IS_PRODUCTION) {
  TagManager.initialize({
    gtmId: HOST_KEYS.GTM,
  })
}

const unmount = () => {
  if (mountRoot) mountRoot.unmount()
  if (sidenavRoot) sidenavRoot.unmount()
  if (footerRoot) footerRoot.unmount()
}

const onRedirectCallback = appState => {
  if (!window.sessionStorage?.getItem('redirect')) window.sessionStorage?.setItem('redirect', appState?.returnTo || '/')
}

LicenseInfo.setLicenseKey(API_KEYS.MUI)

const ProviderWrapper = props => (
  <Provider store={props.store}>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
        <BrowserRouter>
          {props.children}
        </BrowserRouter>
      </LocalizationProvider>
    </ThemeProvider>
  </Provider>
)

const render = () => {
  if (MOUNT_NODE) {
    mountRoot.render(
      <React.StrictMode>
        <Auth0Provider
          domain={config.domain}
          clientId={config.client_id}
          redirectUri={`${BASE_URL}/callback`}
          audience={config.audience}
          onRedirectCallback={onRedirectCallback}
          scope={config.scope}
          useRefreshTokens
          cacheLocation="localstorage"
        >
          <ProviderWrapper store={store}>
            <App />
          </ProviderWrapper>
        </Auth0Provider>
      </React.StrictMode>
    )
  }
  if (HEADER_NODE) {
    sidenavRoot.render(
      <React.StrictMode>
        <Auth0Provider
          domain={config.domain}
          clientId={config.client_id}
          redirectUri={`${BASE_URL}/callback`}
          audience={config.audience}
          scope={config.scope}
          useRefreshTokens
          cacheLocation="localstorage"
        >
          <ProviderWrapper store={store}>
            <GlobalStyle />
            <Header />
          </ProviderWrapper>
        </Auth0Provider>
      </React.StrictMode>
    )
  }
  if (FOOTER_NODE) {
    footerRoot.render(
      <React.StrictMode>
        <ProviderWrapper store={store}>
          <Footer />
        </ProviderWrapper>
      </React.StrictMode>
    )
  }
}

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept([
    'containers/App'
  ], () => {
    unmount()
    render()
  })
}

render()
